<template>
  <v-card outlined elevation="0" class="detail-card">
    <div class="detail-header">
      <div class="detail-badge">
        <v-icon color="primary" size="18">{{ icon }}</v-icon>
      </div>
      <span class="detail-title">{{ title }}</span>
    </div>
    <v-divider />

    <div class="px-4 py-3">
      <v-skeleton-loader
        v-if="loading"
        type="list-item, list-item, list-item"
      />
      <div v-else class="detail-grid">
        <div v-for="(item, i) in items" :key="i" class="detail-row">
          <v-icon x-small class="mr-2 detail-row-icon">{{
            item.icon || 'mdi-information-outline'
          }}</v-icon>
          <span class="detail-label">{{ item.label }}</span>
          <span class="detail-value">{{ display(item.value) }}</span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DetailCard',
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: 'mdi-information-outline' },
    // [{ label, value, icon }]
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  methods: {
    display(value) {
      return value === null || value === undefined || value === ''
        ? 'N/A'
        : value
    },
  },
}
</script>

<style scoped>
.detail-card {
  border: 1px solid #e8edf5;
  background: #ffffff;
  border-radius: 16px;
  height: 100%;
  overflow: hidden;
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
}
.detail-badge {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #eaf1fb;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f2a55;
}
.detail-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}
.detail-row {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  padding: 5px 0;
  border-bottom: 1px solid #f1f4f8;
}
.detail-row-icon {
  color: #475467;
  flex: 0 0 auto;
  margin-top: 1px;
}
.detail-label {
  flex: 0 0 118px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #3f4a5a;
  font-weight: 600;
}
.detail-value {
  flex: 1 1 auto;
  padding-left: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  overflow-wrap: break-word;
}
</style>
